import { useQuery } from 'react-query'

import { api } from '@/utils/apis'

export const useDepositNetworks = () => useQuery({
  queryKey: ['networkOptions'],
  queryFn: async () => {
    const { data } = await api.get('/crosschain_coin_transfer/deposit_networks')
    console.log(data)
    return data
  },
  refetchOnWindowFocus: false,
})
